<template>
  <div class="journalist">
    <div class="journalist-container" ref="journalistContainer">
      <div v-for="(item, index) in items" :key="item?.id" class="card">
        <img
          :src="item?.avatar ? item?.avatar : '/logo.png'"
          :alt="item?.name"
          class="image"
        />
        <div class="static-block-alter">
          <div class="static-alter">
            <svg
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="static-svg-alter"
            >
              <path
                d="M29.5941 3.40927L30.0051 2.64833C30.3527 2.0047 30.1119 1.19819 29.4682 0.850561L28.1899 0.159993C27.878 -0.0084456 27.5192 -0.0453209 27.1795 0.0561799C26.84 0.157618 26.5604 0.385182 26.3921 0.69681L25.5953 2.17182C25.3321 2.26532 25.0886 2.42189 24.8897 2.63889C24.3976 3.17614 23.8852 3.80071 23.3667 4.4934C18.1815 4.18196 12.9309 4.13384 7.75645 4.35153C6.31894 4.41115 4.86824 4.49234 3.44517 4.5929C1.8679 4.70259 0.597895 5.92179 0.425519 7.49205C-0.14161 12.6755 -0.14186 17.9332 0.424894 23.1193C0.59752 24.6924 1.86741 25.9143 3.44298 26.0244C3.55598 26.0326 3.66886 26.0403 3.77867 26.0471C4.08473 26.0678 4.37036 26.2167 4.56205 26.4558C4.65461 26.5713 4.79068 26.6313 4.92799 26.6313C5.03087 26.6313 5.13443 26.5976 5.22099 26.5283C5.42293 26.3663 5.45537 26.0713 5.29337 25.8693C4.93799 25.4262 4.40899 25.1501 3.83923 25.1116C3.73023 25.1048 3.62073 25.0974 3.50979 25.0893C2.38541 25.0107 1.4799 24.1392 1.35684 23.0172C0.797459 17.8989 0.797709 12.7098 1.3574 7.59424C1.48034 6.47523 2.38572 5.60629 3.51073 5.5281C4.92537 5.42816 6.36688 5.34741 7.79564 5.28822C12.741 5.08016 17.7559 5.11616 22.7159 5.39447C22.4025 5.84323 22.089 6.31323 21.7785 6.80155C21.6396 7.01998 21.7041 7.30968 21.9226 7.44861C22.141 7.58743 22.4307 7.52305 22.5697 7.30461C23.583 5.7111 24.6243 4.31671 25.581 3.27227C25.8343 2.99595 26.2425 2.92789 26.5739 3.10677L27.8895 3.8174C28.2212 3.99652 28.3881 4.37509 28.2955 4.73834C27.746 6.90173 26.6304 9.59819 25.1543 12.331C24.5531 13.4438 23.9234 14.5042 23.2862 15.4819L19.3439 13.3525C19.8122 12.2833 20.3529 11.1754 20.9541 10.0622C21.1409 9.71638 22.4117 7.58199 22.5918 7.2678C22.7206 7.04323 22.6428 6.75679 22.4183 6.62798C22.1937 6.49923 21.9072 6.57692 21.7785 6.80155C21.5945 7.12255 20.3199 9.26388 20.1293 9.61663C18.64 12.3745 17.5028 15.1152 16.9271 17.3339C16.3886 19.4096 16.3932 20.8026 16.9379 21.4892L16.8125 21.6935C16.677 21.9141 16.746 22.2027 16.9667 22.3382C17.0432 22.3852 17.1278 22.4075 17.2115 22.4075C17.3691 22.4075 17.5229 22.3281 17.6114 22.184L17.7549 21.9503C17.8104 21.9572 17.8671 21.961 17.9251 21.961C18.7833 21.9609 19.9082 21.1992 21.281 19.6857C22.8211 17.9878 24.4896 15.5341 25.9792 12.7766C26.4332 11.9361 26.8533 11.0983 27.2355 10.2764C27.2673 10.7248 27.2936 11.1736 27.3169 11.6228C27.2792 11.6793 27.2415 11.7356 27.204 11.7916C25.6191 14.1615 24.6527 15.6591 24.7494 16.5456C24.7756 16.7856 24.9787 16.9635 25.2148 16.9635C25.2318 16.9635 25.249 16.9626 25.2662 16.9607C25.5235 16.9326 25.7095 16.7013 25.6814 16.4439C25.6287 15.9612 26.4906 14.5685 27.3821 13.2162C27.4784 16.4881 27.3497 19.7705 26.9941 23.0218C26.9681 23.2538 26.9095 23.476 26.819 23.6844C26.474 24.4901 25.7162 25.0284 24.8408 25.0894C21.0575 25.3551 17.2077 25.4805 13.3971 25.4608C12.7229 25.4566 12.0937 25.7826 11.7143 26.3301C10.4997 28.0771 8.49321 29.7784 7.02388 30.8979C6.77738 31.0857 6.46431 31.1156 6.18663 30.978C5.90837 30.8401 5.74225 30.5723 5.74225 30.2614V28.1839C5.74225 27.925 5.53243 27.7151 5.27349 27.7151C5.01455 27.7151 4.80474 27.925 4.80474 28.1839V30.2614C4.80474 30.9265 5.17481 31.523 5.7705 31.8181C6.01675 31.9401 6.28063 32.0001 6.54275 32.0001C6.91413 32.0001 7.2822 31.8796 7.59195 31.6436C9.11483 30.4832 11.1999 28.7123 12.4844 26.8646C12.687 26.5723 13.0241 26.3982 13.3868 26.3982H13.3923C17.2248 26.4171 21.0996 26.2919 24.9061 26.0246C26.1337 25.939 27.1968 25.1836 27.6797 24.0556C27.8065 23.7637 27.8894 23.4509 27.9258 23.1247C28.3334 19.3976 28.4474 15.6307 28.2692 11.8846C29.5929 9.90045 30.8841 7.8993 31.1066 6.51917C31.3259 5.15622 30.778 4.04746 29.5941 3.40927ZM20.5864 19.0558C18.926 20.8863 18.0321 21.1309 17.7656 20.9869C17.4991 20.843 17.2138 19.9613 17.8345 17.5691C18.0984 16.5517 18.4872 15.4172 18.9766 14.2195L22.7624 16.2644C22.0287 17.3308 21.2928 18.277 20.5864 19.0558ZM27.0193 2.2817C26.9086 2.22195 26.7937 2.17663 26.6768 2.14238L27.2171 1.14238C27.2664 1.051 27.3485 0.98425 27.448 0.9545C27.5475 0.924687 27.6529 0.935499 27.7444 0.984937L29.0227 1.67551C29.2116 1.77751 29.2822 2.01407 29.1803 2.20288L28.6401 3.20289C28.5472 3.12383 28.446 3.05245 28.3352 2.99252L27.0193 2.2817ZM30.1809 6.37004C30.0259 7.33155 29.1536 8.81656 28.1777 10.3205C28.1347 9.70151 28.0837 9.08338 28.0245 8.46631C28.5325 7.21624 28.9341 6.03173 29.204 4.96934C29.2626 4.73922 29.2717 4.50653 29.2389 4.28253C30.0149 4.73309 30.3317 5.43329 30.1809 6.37004Z"
                fill="black"
                fill-opacity="0.4"
              />
            </svg>
            <span class="static-text-alter">{{ item?.news_views_count }}</span>
          </div>
          <div class="static-alter">
            <svg
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="static-svg-alter"
            >
              <g clip-path="url(#clip0)">
                <path
                  d="M31.8815 15.6218C31.6295 15.2551 25.5734 6.66699 15.9999 6.66699C7.78511 6.66699 0.464992 15.2058 0.156987 15.5698C-0.0523289 15.8178 -0.0523289 16.1818 0.156987 16.4311C0.464992 16.7951 7.78511 25.334 15.9999 25.334C24.2147 25.334 31.5348 16.7951 31.8428 16.4311C32.0362 16.2018 32.0535 15.8698 31.8815 15.6218ZM15.9999 24.0006C9.41451 24.0006 3.15303 17.7205 1.56238 16.0005C3.15041 14.2792 9.40519 8.00039 15.9999 8.00039C23.7054 8.00039 29.1441 14.2712 30.4721 15.9645C28.9387 17.6298 22.6413 24.0006 15.9999 24.0006Z"
                  fill="black"
                  fill-opacity="0.4"
                />
                <path
                  d="M16.0001 10.667C13.0588 10.667 10.6667 13.059 10.6667 16.0004C10.6667 18.9418 13.0588 21.3338 16.0001 21.3338C18.9415 21.3338 21.3335 18.9418 21.3335 16.0004C21.3335 13.059 18.9415 10.667 16.0001 10.667ZM16.0001 20.0005C13.7948 20.0005 12.0001 18.2058 12.0001 16.0005C12.0001 13.7951 13.7948 12.0004 16.0001 12.0004C18.2055 12.0004 20.0002 13.7951 20.0002 16.0005C20.0002 18.2058 18.2055 20.0005 16.0001 20.0005Z"
                  fill="black"
                  fill-opacity="0.4"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="32" height="32" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <span class="static-text">{{ item?.news_views_count }}</span>
          </div>
        </div>
        <div class="text-block">
          <h4 class="name">{{ item?.first_name }} {{ item?.last_name }}</h4>
          <h4 class="name-url">{{ item?.username }}</h4>
          <div class="static-block">
            <div class="static">
              <span class="static-hover">{{
                $t("staff_page.count_news")
              }}</span>
              <svg
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="static-svg"
              >
                <path
                  d="M29.5941 3.40927L30.0051 2.64833C30.3527 2.0047 30.1119 1.19819 29.4682 0.850561L28.1899 0.159993C27.878 -0.0084456 27.5192 -0.0453209 27.1795 0.0561799C26.84 0.157618 26.5604 0.385182 26.3921 0.69681L25.5953 2.17182C25.3321 2.26532 25.0886 2.42189 24.8897 2.63889C24.3976 3.17614 23.8852 3.80071 23.3667 4.4934C18.1815 4.18196 12.9309 4.13384 7.75645 4.35153C6.31894 4.41115 4.86824 4.49234 3.44517 4.5929C1.8679 4.70259 0.597895 5.92179 0.425519 7.49205C-0.14161 12.6755 -0.14186 17.9332 0.424894 23.1193C0.59752 24.6924 1.86741 25.9143 3.44298 26.0244C3.55598 26.0326 3.66886 26.0403 3.77867 26.0471C4.08473 26.0678 4.37036 26.2167 4.56205 26.4558C4.65461 26.5713 4.79068 26.6313 4.92799 26.6313C5.03087 26.6313 5.13443 26.5976 5.22099 26.5283C5.42293 26.3663 5.45537 26.0713 5.29337 25.8693C4.93799 25.4262 4.40899 25.1501 3.83923 25.1116C3.73023 25.1048 3.62073 25.0974 3.50979 25.0893C2.38541 25.0107 1.4799 24.1392 1.35684 23.0172C0.797459 17.8989 0.797709 12.7098 1.3574 7.59424C1.48034 6.47523 2.38572 5.60629 3.51073 5.5281C4.92537 5.42816 6.36688 5.34741 7.79564 5.28822C12.741 5.08016 17.7559 5.11616 22.7159 5.39447C22.4025 5.84323 22.089 6.31323 21.7785 6.80155C21.6396 7.01998 21.7041 7.30968 21.9226 7.44861C22.141 7.58743 22.4307 7.52305 22.5697 7.30461C23.583 5.7111 24.6243 4.31671 25.581 3.27227C25.8343 2.99595 26.2425 2.92789 26.5739 3.10677L27.8895 3.8174C28.2212 3.99652 28.3881 4.37509 28.2955 4.73834C27.746 6.90173 26.6304 9.59819 25.1543 12.331C24.5531 13.4438 23.9234 14.5042 23.2862 15.4819L19.3439 13.3525C19.8122 12.2833 20.3529 11.1754 20.9541 10.0622C21.1409 9.71638 22.4117 7.58199 22.5918 7.2678C22.7206 7.04323 22.6428 6.75679 22.4183 6.62798C22.1937 6.49923 21.9072 6.57692 21.7785 6.80155C21.5945 7.12255 20.3199 9.26388 20.1293 9.61663C18.64 12.3745 17.5028 15.1152 16.9271 17.3339C16.3886 19.4096 16.3932 20.8026 16.9379 21.4892L16.8125 21.6935C16.677 21.9141 16.746 22.2027 16.9667 22.3382C17.0432 22.3852 17.1278 22.4075 17.2115 22.4075C17.3691 22.4075 17.5229 22.3281 17.6114 22.184L17.7549 21.9503C17.8104 21.9572 17.8671 21.961 17.9251 21.961C18.7833 21.9609 19.9082 21.1992 21.281 19.6857C22.8211 17.9878 24.4896 15.5341 25.9792 12.7766C26.4332 11.9361 26.8533 11.0983 27.2355 10.2764C27.2673 10.7248 27.2936 11.1736 27.3169 11.6228C27.2792 11.6793 27.2415 11.7356 27.204 11.7916C25.6191 14.1615 24.6527 15.6591 24.7494 16.5456C24.7756 16.7856 24.9787 16.9635 25.2148 16.9635C25.2318 16.9635 25.249 16.9626 25.2662 16.9607C25.5235 16.9326 25.7095 16.7013 25.6814 16.4439C25.6287 15.9612 26.4906 14.5685 27.3821 13.2162C27.4784 16.4881 27.3497 19.7705 26.9941 23.0218C26.9681 23.2538 26.9095 23.476 26.819 23.6844C26.474 24.4901 25.7162 25.0284 24.8408 25.0894C21.0575 25.3551 17.2077 25.4805 13.3971 25.4608C12.7229 25.4566 12.0937 25.7826 11.7143 26.3301C10.4997 28.0771 8.49321 29.7784 7.02388 30.8979C6.77738 31.0857 6.46431 31.1156 6.18663 30.978C5.90837 30.8401 5.74225 30.5723 5.74225 30.2614V28.1839C5.74225 27.925 5.53243 27.7151 5.27349 27.7151C5.01455 27.7151 4.80474 27.925 4.80474 28.1839V30.2614C4.80474 30.9265 5.17481 31.523 5.7705 31.8181C6.01675 31.9401 6.28063 32.0001 6.54275 32.0001C6.91413 32.0001 7.2822 31.8796 7.59195 31.6436C9.11483 30.4832 11.1999 28.7123 12.4844 26.8646C12.687 26.5723 13.0241 26.3982 13.3868 26.3982H13.3923C17.2248 26.4171 21.0996 26.2919 24.9061 26.0246C26.1337 25.939 27.1968 25.1836 27.6797 24.0556C27.8065 23.7637 27.8894 23.4509 27.9258 23.1247C28.3334 19.3976 28.4474 15.6307 28.2692 11.8846C29.5929 9.90045 30.8841 7.8993 31.1066 6.51917C31.3259 5.15622 30.778 4.04746 29.5941 3.40927ZM20.5864 19.0558C18.926 20.8863 18.0321 21.1309 17.7656 20.9869C17.4991 20.843 17.2138 19.9613 17.8345 17.5691C18.0984 16.5517 18.4872 15.4172 18.9766 14.2195L22.7624 16.2644C22.0287 17.3308 21.2928 18.277 20.5864 19.0558ZM27.0193 2.2817C26.9086 2.22195 26.7937 2.17663 26.6768 2.14238L27.2171 1.14238C27.2664 1.051 27.3485 0.98425 27.448 0.9545C27.5475 0.924687 27.6529 0.935499 27.7444 0.984937L29.0227 1.67551C29.2116 1.77751 29.2822 2.01407 29.1803 2.20288L28.6401 3.20289C28.5472 3.12383 28.446 3.05245 28.3352 2.99252L27.0193 2.2817ZM30.1809 6.37004C30.0259 7.33155 29.1536 8.81656 28.1777 10.3205C28.1347 9.70151 28.0837 9.08338 28.0245 8.46631C28.5325 7.21624 28.9341 6.03173 29.204 4.96934C29.2626 4.73922 29.2717 4.50653 29.2389 4.28253C30.0149 4.73309 30.3317 5.43329 30.1809 6.37004Z"
                  fill="black"
                  fill-opacity="0.4"
                />
              </svg>
              <span class="static-text">{{ item?.news_count }}</span>
            </div>
            <div class="static">
              <span class="static-hover">{{
                $t("staff_page.count_views")
              }}</span>
              <svg
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="static-svg"
              >
                <g clip-path="url(#clip0)">
                  <path
                    d="M31.8815 15.6218C31.6295 15.2551 25.5734 6.66699 15.9999 6.66699C7.78511 6.66699 0.464992 15.2058 0.156987 15.5698C-0.0523289 15.8178 -0.0523289 16.1818 0.156987 16.4311C0.464992 16.7951 7.78511 25.334 15.9999 25.334C24.2147 25.334 31.5348 16.7951 31.8428 16.4311C32.0362 16.2018 32.0535 15.8698 31.8815 15.6218ZM15.9999 24.0006C9.41451 24.0006 3.15303 17.7205 1.56238 16.0005C3.15041 14.2792 9.40519 8.00039 15.9999 8.00039C23.7054 8.00039 29.1441 14.2712 30.4721 15.9645C28.9387 17.6298 22.6413 24.0006 15.9999 24.0006Z"
                    fill="black"
                    fill-opacity="0.4"
                  />
                  <path
                    d="M16.0001 10.667C13.0588 10.667 10.6667 13.059 10.6667 16.0004C10.6667 18.9418 13.0588 21.3338 16.0001 21.3338C18.9415 21.3338 21.3335 18.9418 21.3335 16.0004C21.3335 13.059 18.9415 10.667 16.0001 10.667ZM16.0001 20.0005C13.7948 20.0005 12.0001 18.2058 12.0001 16.0005C12.0001 13.7951 13.7948 12.0004 16.0001 12.0004C18.2055 12.0004 20.0002 13.7951 20.0002 16.0005C20.0002 18.2058 18.2055 20.0005 16.0001 20.0005Z"
                    fill="black"
                    fill-opacity="0.4"
                  />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="32" height="32" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <span class="static-text">{{ item?.news_views_count }}</span>
            </div>
          </div>
          <div
            class="about"
            :class="[activeIndex === index ? 'news-alter' : '']"
          >
            <h3 v-if="item?.bio" class="about-title">
              {{ $t("staff_page.about_me") }}
            </h3>
            <h3 v-if="item?.bio" class="about-info" v-html="item?.bio"></h3>
            <h3 class="latest-news">{{ $t("staff_page.last_news") }}</h3>
            <router-link
              :to="{
                name: `${item.lang}_NewsDetail`,
                params: { slug: article?.url }
              }"
              class="news-block"
              v-for="article in item?.author_news"
              :key="article?.id"
            >
              <h5 class="news-category">{{ article?.sub_category?.name }}</h5>
              <h4 class="news-text limited-text" style="--snup: 3">
                {{ article?.title }}
              </h4>
              <h3 class="news-data">
                {{ handleDate(article?.pub_date) }},
                {{ handleTime(article?.pub_date) }}
              </h3>
            </router-link>
          </div>
          <h3 class="latest-news-alter" @click="ScrollTop(index)">
            {{ $t("staff_page.last_news") }}
          </h3>
        </div>
      </div>
    </div>
    <div
      v-if="show.spinner"
      style="
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 44px 0;
        "
    >
      <div class="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, computed, reactive, watchEffect } from "vue";
import { useStore } from "vuex";
import { useInfiniteScroll } from "@/utils/infiniteScroll";
import { useLanguage } from "@/utils/language";
import { useFormatter } from "@/utils/formatter";

export default {
  name: "Journalist",

  setup() {
    const activeNews = ref(false);
    const activeIndex = ref(null);
    const journalistContainer = ref();
    const ScrollTop = index => {
      if (activeIndex.value !== index) {
        activeIndex.value = index;
      } else {
        activeIndex.value = null;
        journalistContainer.value.children[
          index
        ].children[2].children[3].scrollTop = 0;
      }
    };

    const store = useStore();
    const { i18n } = useLanguage();
    const show = reactive({
      spinner: true
    });

    const inner = ref(null);
    const scrollEnd = () => {
      show.spinner = false;
    };

    const { startInfiniteScroll, loadData } = useInfiniteScroll({
      wrapper: journalistContainer,
      retrieve: (load, cb) => {
        store.dispatch("getJournalists", { cb });
      },
      newsCount: computed(() => store.getters.journalistsCount),
      currentPage: computed(() => store.getters.journalistsPage),
      pageSize: 10,
      scrollEnd
    });

    const refreshData = () => {
      // Necessary to empty the news feed when
      // routing through pages
      store.commit("flushJournalistsState");

      show.spinner = true;
      startInfiniteScroll();
      loadData();
    };

    // It is not essential to re-run this function
    // but you can if you need to.
    // All it does is just <<restarts>> your page
    refreshData();

    watchEffect(() => i18n.global.locale.value, refreshData);

    return {
      activeNews,
      activeIndex,
      journalistContainer,
      ScrollTop,
      inner,
      show,
      items: computed(() => store.getters.journalists),
      ...useFormatter()
    };
  }
};
</script>
<style lang="scss" scoped>
.journalist {
  position: relative;
  margin-top: 25vw;
  z-index: 10;
  width: 100%;
  .journalist-container {
    position: relative;
    width: 90%;
    // max-width: 1280px;
    margin: 0 auto;
    // display: grid;
    // grid-template-columns: 1fr 1fr 1fr;
    // grid-gap: 240px 7.8vw;
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: space-evenly;
    .card {
      max-width: 320px;
      width: 100%;
      background: #ffffff;
      border-radius: 0.78vw;
      position: relative;
      cursor: pointer;
      margin-top: 220px;
      .static-block-alter {
        display: none;
      }
      .image {
        width: 228px;
        height: 228px;
        position: absolute;
        border-radius: 0.78vw;
        left: 50%;
        transform: translate(-50%, -75%);
      }
      .text-block {
        position: relative;
        .name {
          position: relative;
          font-family: Open Sans;
          font-style: normal;
          font-weight: 600;
          font-size: 1.3125em;
          line-height: 1.3;
          text-align: center;
          color: #3e4c60;
          margin-top: 63px;
          margin-bottom: 4px;
        }
        .name-url {
          position: relative;
          font-style: normal;
          font-weight: 300;
          font-size: 1.13em;
          line-height: 1.3;
          text-align: center;
          color: #6c8fba;
        }
        .static-block {
          position: relative;
          font-family: Open Sans;
          font-style: normal;
          font-weight: 600;
          font-size: 1.19em;
          line-height: 1.3;
          text-align: center;
          color: rgba(18, 18, 18, 0.75);
          margin-top: 0.93vw;
          margin-bottom: 1.19vw;
          display: flex;
          align-items: center;
          justify-content: center;
          .static {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 45%;
            .static-hover {
              opacity: 0;
              position: absolute;
              font-size: 0.9em;
              top: 0;
              left: 50%;
              white-space: nowrap;
              transform: translate(-50%, -100%);
              transition: all 0.5s;
            }
            .static-svg {
              width: 20%;
            }
            .static-text {
              margin-left: 10%;
            }
            &:hover {
              .static-hover {
                opacity: 1;
              }
            }
          }
        }
        .about {
          position: relative;
          max-height: 389px;
          overflow-y: scroll;
          display: flex;
          flex-direction: column;
          width: 93%;
          margin: 0 auto 0.72vw auto;
          &::-webkit-scrollbar {
            width: 6px;
            background: #ffffff;
          }

          &::-webkit-scrollbar-thumb {
            background: rgba(67, 82, 101, 0.5);
            border-radius: 3px;
          }
          .about-title {
            position: relative;
            font-style: normal;
            font-weight: 550;
            font-size: 0.94em;
            line-height: 1.2;
            color: #6c8fba;
          }
          .about-info {
            position: relative;
            font-style: normal;
            font-weight: normal;
            font-size: 1em;
            line-height: 1.2;
            color: #586574;
            margin-top: 3px;
            margin-bottom: 15px;
            padding: 0.7vw;
            background: #f8f8f8;
            border: 1px solid #9ec1ec;
            box-sizing: border-box;
            box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.03);
            // word-break: break-all;
          }
          .latest-news {
            position: relative;
            font-family: Open Sans;
            font-style: normal;
            font-weight: 300;
            font-size: 0.94em;
            line-height: 1.25;
            color: #121212;
            margin-bottom: 1vw;
          }
          .news-block {
            position: relative;
            margin-bottom: 0.5vw;
            background: #fafafa;
            border-radius: 4px;
            padding: 0.5vw 1.35vw;
            border-radius: 4px;
            .news-category {
              position: relative;
              font-family: Open Sans;
              font-style: normal;
              font-weight: normal;
              font-size: 0.8125em;
              line-height: 1.4;
              color: rgba(18, 18, 18, 0.7);
            }
            .news-text {
              position: relative;
              font-family: Roboto;
              font-style: normal;
              font-weight: 500;
              font-size: 1em;
              line-height: 1.25;
              color: #121212;
              margin: 3px 0;
            }
            .news-data {
              position: relative;
              font-family: Open Sans;
              font-style: normal;
              font-weight: 300;
              font-size: 0.75em;
              line-height: 1.25;
              color: rgba(18, 18, 18, 0.7);
            }
          }
        }
        .latest-news-alter {
          display: none;
        }
      }
    }
  }
}
@media screen and (max-width: 1300px) {
  .journalist {
    margin-top: 50vw;
    .journalist-container {
      .card {
        margin-top: 150px;
        .image {
          width: 200px;
          height: 200px;
          transform: translate(-50%, -70%);
        }
      }
    }
  }
}
@media screen and (max-width: 978px) {
  .journalist {
    margin-top: 30vw;
    .journalist-container {
      // grid-template-columns: 1fr 1fr;
      .card {
        margin-top: 140px;
        border-radius: 1.95vw;
        .image {
          border-radius: 1.95vw;
          transform: translate(-50%, -70%);
        }
        .text-block {
          .static-block {
            .static {
              .static-hover {
                display: none;
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .journalist {
    margin-top: 90vw;
  }
}
@media screen and (max-width: 550px) {
  .journalist {
    .journalist-container {
      .card {
        margin-top: 150px;
      }
    }
  }
}
@media screen and (max-width: 375px) {
  .journalist {
    margin-top: 115vw;
    .journalist-container {
      .card {
        margin-top: 70px;
        border-radius: 9px;
        .static-block-alter {
          position: relative;
          font-family: Open Sans;
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          line-height: 1.3;
          text-align: center;
          color: rgba(18, 18, 18, 0.75);
          margin-top: 20px;
          margin-bottom: 1.19vw;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .static-alter {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 25%;
            .static-svg-alter {
              width: 40%;
            }
          }
        }
        .image {
          width: 130px;
          height: 130px;
          position: absolute;
          border-radius: 9px;
          left: 50%;
          transform: translate(-50%, -55%);
        }
        .text-block {
          position: relative;
          .name {
            font-weight: 600;
            font-size: 20px;
            margin-top: 1px;
          }
          .name-url {
            font-size: 16px;
          }
          .static-block {
            display: none;
          }
          .about {
            max-height: inherit;
            width: 85%;
            transition: all 5s;
            max-height: 200px;
            transition: all 1s;
            overflow: hidden;
            &::-webkit-scrollbar {
              width: inherit;
              background: inherit;
            }

            &::-webkit-scrollbar-thumb {
              background: inherit;
              border-radius: inherit;
            }
            .about-title {
              margin-top: 15px;
              font-size: 15px;
              line-height: 1;
            }
            .about-info {
              font-size: 15px;
              line-height: 1.2;
              margin-top: 3px;
              margin-bottom: 20px;
              padding: 15px;
            }
            .latest-news {
              display: none;
            }
            .news-block {
              width: 80%;
              margin: 0 auto;
              margin-bottom: 10px;
              background: #fafafa;
              border-radius: 4px;
              padding: 17px 15px;
              border-radius: 5px;
              .news-category {
                text-transform: uppercase;
                font-weight: 600;
                font-size: 13px;
              }
              .news-text {
                font-size: 14px;
                margin: 5px 0;
              }
              .news-data {
                font-size: 13px;
              }
            }
          }
          .news-alter {
            max-height: 580px;
            overflow: scroll;
          }
          .latest-news-alter {
            display: block;
            position: relative;
            font-family: Open Sans;
            font-style: normal;
            font-weight: 300;
            font-size: 15px;
            line-height: 1.25;
            color: rgba(62, 76, 96, 0.7);
            margin-bottom: 20px;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
